/* eslint-disable */

import $ from 'jquery';

/* eslint-enable */

export default () => {
  $(document).ready(function() {
    $.fn.equivalent = function() {
      const $blocks = $(this);

      let maxH = $blocks.eq(0).height();

      $blocks.each(function() {
        maxH = $(this).height() > maxH ? $(this).height() : maxH;
      });

      $blocks.height(maxH);
    };

    $('.courses-grid  .title-course').equivalent();
  });
};
